/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createStore, applyMiddleware, Middleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { composeWithDevTools as composeWithDevToolsPro } from 'redux-devtools-extension/developmentOnly';
import { encryptTransform } from 'redux-persist-transform-encrypt';

import {
  persistStore,
  persistReducer,
  PersistState,
  PersistedState,
} from 'redux-persist';
import Cookies from 'js-cookie';


import { AuthAction, AuthState } from './modules/auth/types';
import { ProductAction, ProductState } from './modules/product/types';
import { CategoryAction, CategoryState } from './modules/category/types';
import { ParameterAction, ParameterState } from './modules/parameter/types';
import rootReducer from './modules/rootReducer';
import { checkoutState } from './modules/checkout/types';
import { OrderAction, OrderState } from './modules/order/types';

export interface StoreState {
  auth: AuthState;
  product: ProductState;
  category: CategoryState;
  checkout: checkoutState;
  parameter: ParameterState;
  order: OrderState;
}

export type StoreAction =
  | AuthAction
  | ProductAction
  | CategoryAction
  | ParameterAction
  | OrderAction;

const persistConfig = {
  version: process.env.REACT_APP_VERSION_STATE_REDUX
    ? Number(process.env.REACT_APP_VERSION_STATE_REDUX)
    : 1,
  key: '@ConectoVarejo:State',
  storage: {
    getItem: (key: string) => {
      return new Promise(resolve => {
        resolve(Cookies.get(key));
      });
    },
    setItem: (key: string, value: string) => {
      Cookies.set(key, value);
    },
    removeItem: (key: string) => {
      Cookies.remove(key);
    },
  },
  whitelist: ['user'],
  transforms: [
    encryptTransform({
      secretKey: process.env.REACT_APP_LOCAL_STORAGE_KEY || 'NOT_KEY',
    }),
  ],
  migrate: (state: PersistedState, currentVersion: number) => {
    const previousVersion = state?._persist?.version;
    if (previousVersion !== currentVersion) {
      return Promise.resolve({
        _persist: state?._persist || ({} as PersistState),
      });
    }

    return Promise.resolve({
      ...state,
      _persist: state?._persist || ({} as PersistState),
    });
  },
};


const persistedReducer = persistReducer(persistConfig, rootReducer);

export default (middlewares: Middleware[]) => {
  let store;

  if (process.env.REACT_APP_MODE_PRODUCTION === '1') {
    store = createStore(
      persistedReducer,
      composeWithDevToolsPro(applyMiddleware(...middlewares)),
    );
  } else {
    store = createStore(
      persistedReducer,
      composeWithDevTools(applyMiddleware(...middlewares)),
    );
  }

  const persistor = persistStore(store);

  return { store, persistor };
};


//redux persist reduxSaga